import { useState } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
	{ label: "Home", href: "#" },
	{ label: "Courses", href: "#courses" },
	{ label: "Enquiry", href: "#enquiry" },
	{ label: "Leaderboard", href: "#leaderboard" },
	{ label: "Contact", href: "#contact" },
];

const Navbar = () => {
	const [open, setOpen] = useState(false);

	return (
		<nav className="fixed top-0 left-0 right-0 z-50 bg-maroon-deep/90 backdrop-blur-md border-b border-gold/20">
		<div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
			<a href="#" className="font-display text-xl font-bold text-gold-gradient tracking-wider">
				SWAR NRITYAM
			</a>

			<div className="hidden md:flex items-center gap-8">
				{navLinks.map((link) => (
					<a
						key={link.label}
						href={link.href}
						className="text-cream/80 font-body text-sm tracking-wide hover:text-gold transition-colors duration-200"
					>
						{link.label}
					</a>
				))}
			</div>

			<button
				onClick={() => setOpen(!open)}
				className="md:hidden text-cream/80 hover:text-gold transition-colors"
			>
				{open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
			</button>
		</div>

		{open && (
			<div className="md:hidden bg-maroon-deep/95 backdrop-blur-md border-t border-gold/10 px-4 pb-4">
				{navLinks.map((link) => (
					<a
						key={link.label}
						href={link.href}
						onClick={() => setOpen(false)}
						className="block py-3 text-cream/80 font-body text-sm tracking-wide hover:text-gold transition-colors border-b border-gold/10 last:border-0"
					>
						{link.label}
					</a>
				))}
			</div>
		)}
		</nav>
	);
};

export default Navbar;
